import { shouldHighlightBrokenLimit } from '../utils/brokenLimitUtils';

export const hasLimitValue = value => value !== null && value !== undefined && value !== '';

export const normalizePercentageLimit = value => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) return numericValue;

  return Number((numericValue * 100).toFixed(10));
};

export const isOutsidePercentageLimit = (value, min, max) => {
  if (!hasLimitValue(value)) return false;

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) return false;

  if (hasLimitValue(max) && numericValue > normalizePercentageLimit(max)) return true;
  if (hasLimitValue(min) && numericValue < normalizePercentageLimit(min)) return true;

  return false;
};

// Linha não editada: quem decide a quebra é a API. Linha editada: cálculo local.
// A linha de oferta (ExpandedRowPrice) não traz brokenLimit: sem veredito da API
// não há o que consultar, então vale o cálculo local.
const evaluateLimit = (content, localBroken, type) => {
  if (content?.brokenLimit === undefined) return localBroken;

  return shouldHighlightBrokenLimit({ rowData: content, localBroken, type });
};

export const isMarginLimitBroken = (content, margin) =>
  evaluateLimit(content, isOutsidePercentageLimit(margin, content?.minMargin, content?.maxMargin), 'MARGIN');

export const isCompetitivenessLimitBroken = (content, cpi) =>
  evaluateLimit(content, isOutsidePercentageLimit(cpi, content?.minCpi, content?.maxCpi), 'COMPETITIVENESS');
